import { APICompsSchema } from "@unit/apis";
import { atom, useAtom } from "jotai";

const spotlightsAtom = atom<APICompsSchema["SpotlightObject"][]>([]);

export const useSpotlightState = () => {
  const [spotlightList, setSpotlightList] = useAtom(spotlightsAtom);

  const popupSpotlight = spotlightList.find((spotlightList) => spotlightList.isFirstOpen);

  return {
    spotlightList,
    popupSpotlight,
    setSpotlightList,
  };
};
